<template>
  <div>
    <vue-ins-progress-bar />
    <component :is="layout">
      <transition
        name="page-fade"
        mode="out-in"
      >
        <RouterView :key="$route.path" />
      </transition>
    </component>
    <!-- Global scroll-to-top removed - Landing page has its own styled button -->
    <div id="swal-output" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { Network } from '@capacitor/network'

import MainLayout from '@/components/layouts/MainLayout.vue'
import AuthorizationLayout from '@/components/layouts/AuthorizationLayout.vue'
import BlankLayout from '@/components/layouts/BlankLayout.vue'
import LandingLayout from '@/components/layouts/LandingLayout.vue'

import MxMisc from '@/mixins/misc'

export default {
  name: 'App',
  components: {
    'layout-main': MainLayout,
    'layout-auth': AuthorizationLayout,
    'layout-blank': BlankLayout,
    'layout-landing': LandingLayout
  },
  mixins: [
    MxMisc
  ],
  metaInfo () {
    const appName = process.env?.VUE_APP_TITLE || 'OSAS'
    return {
      title: appName,
      titleTemplate: `%s · ${appName}`
    }
  },
  computed: Object.assign(
    {
      layout () {
        switch (this.$route.meta.layout) {
          case 'auth': {
            return 'layout-auth'
          }
          case 'sso': {
            return 'layout-blank'
          }
          case 'landing': {
            return 'layout-landing'
          }
          default: {
            if (this.user?.id) {
              return 'layout-main'
            }

            return 'layout-auth'
          }
        }
      }
    },
    mapGetters({
      offline: 'offline-storage/offlineState',
      user: 'auth/user'
    })
  ),

  mounted () {
    try {
      this.initListener()
    } catch (error) {
      console.error('Network listener init failed:', error)
    }

    if (this.$insProgress?.finish) {
      this.$insProgress.finish()
    }
  },

  destroyed () {
    if (Network?.removeAllListeners) {
      Network.removeAllListeners()
    }
  },

  methods: {
    initListener () {
      if (!Network?.addListener) {
        return
      }

      Network.addListener('networkStatusChange', networkConnection => {
        this.$bvToast.toast(networkConnection.connected ? 'Internet connection restored' : 'You are currently working offline', {
          title: 'Network Status',
          toaster: 'b-toaster-top-center',
          solid: true,
          appendToast: true,
          noCloseButton: true,
          autoHideDelay: 3000,
          variant: networkConnection.connected ? 'success' : 'danger'
        })

        this.offlineAction(!networkConnection.connected)
      })
    },

    ...mapActions({
      offlineAction: 'offline-storage/offlineAction'
    })
  }
}
</script>
<style lang="scss">
  @import "./assets/scss/style.scss";
</style>
<style>
  @import "./assets/css/custom.css";

  /* Page transition animation */
  .page-fade-enter-active,
  .page-fade-leave-active {
    transition: opacity 0.25s ease, transform 0.25s ease;
  }
  .page-fade-enter {
    opacity: 0;
    transform: translateY(8px);
  }
  .page-fade-leave-to {
    opacity: 0;
    transform: translateY(-8px);
  }
</style>
